import { call, put, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { MAIN_PATH, PATH_DELIMITER, SYSTEM_USER_PATH } from '../../../constant/Constant';
import { request } from '../../ApiModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { SET_GRID_DATA } from '../../component/TableBoxModule';
import AuthenticationUtil from '../../../util/AuthenticationUtil';

const ACTION_USER_SEARCH = SYSTEM_USER_PATH + PATH_DELIMITER + 'ACTION_USER_SEARCH';
const ACTION_USER_ADD = SYSTEM_USER_PATH + PATH_DELIMITER + 'ACTION_USER_ADD';
const ACTION_USER_EDIT = SYSTEM_USER_PATH + PATH_DELIMITER + 'ACTION_USER_EDIT';
const ACTION_USER_REMOVE = SYSTEM_USER_PATH + PATH_DELIMITER + 'ACTION_USER_REMOVE';
const ACTION_USER_PWRESET = SYSTEM_USER_PATH + PATH_DELIMITER + 'ACTION_USER_PWRESET';
const ACTION_CHANGE_USER = SYSTEM_USER_PATH + PATH_DELIMITER + 'ACTION_CHANGE_USER';

export const actionUserSearch = createAction(ACTION_USER_SEARCH);
export const actionUserAdd = createAction(ACTION_USER_ADD);
export const actionUserEdit = createAction(ACTION_USER_EDIT);
export const actionUserRemove = createAction(ACTION_USER_REMOVE);
export const actionUserPwreset = createAction(ACTION_USER_PWRESET);
export const actionChangeUser = createAction(ACTION_CHANGE_USER);

export function* systemUserSagas() {
    yield takeEvery(ACTION_USER_SEARCH, actionUserSearchSaga);
    yield takeEvery(ACTION_USER_ADD, actionUserAddSaga);
    yield takeEvery(ACTION_USER_EDIT, actionUserEditSaga);
    yield takeEvery(ACTION_USER_REMOVE, actionUserRemoveSaga);
    yield takeEvery(ACTION_USER_PWRESET, actionUserPwresetSaga);
    yield takeEvery(ACTION_CHANGE_USER, actionChangeUserSaga);
}

function* actionUserSearchSaga({ payload: { params, callback } }) {
    const result = yield call(request, {
        method: 'get',
        url: '/api/users',
        params,
        callback,
    });

    if (NullCheckUtil.isNotEmpty(result)) {
        yield put({
            type: SET_GRID_DATA,
            payload: result,
        });
    }
}

function* actionUserAddSaga({ payload: { data, callback } }) {
    console.log(data);
    const result = yield call(request, {
        method: 'post',
        url: '/api/users/add-by-admin',
        data,
    });

    if (NullCheckUtil.isNotEmpty(result) && result == 1) {
        let params = data;
        callback && callback(params);
    }
}

function* actionUserEditSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'put',
        url: `/api/users/${data.userId}/change-info`,
        data,
        callback,
    });
}

function* actionUserRemoveSaga({ payload: { params, callback } }) {
    yield call(request, {
        method: 'delete',
        url: `/api/users/${params.userId}`,
        params,
        callback,
    });
}

function* actionUserPwresetSaga({ payload: { data, callback } }) {
    yield call(request, {
        method: 'post',
        url: '/api/email/reset-password',
        data,
        callback,
    });
}

function* actionChangeUserSaga({ payload: { data } }) {
    const result = yield call(request, {
        method: 'post',
        url: '/auth/change',
        data,
    });
    if (NullCheckUtil.isNotNull(result)) {
        AuthenticationUtil.set(result);
        window.history.pushState({}, '', MAIN_PATH);
        window.location.reload();
    }
}
